import React from 'react';

import upsolveStats from '../../../content/onBuild/upsolveStats';
import { H5 } from '../Type/Display.h';
import P from '../Type/Paragraph.p';
import { ButtonLink } from '../Inputs/Button.span';

const SidebarCta = () => (
  <div>
    <H5>Clear Your Debt</H5>
    <P>Filing chapter 7 bankruptcy with Upsolve can clear medical, credit card, and pay day loan debt. <b>Our users on average clear ${upsolveStats.debtCleared.averagePerFiler.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} of debt</b> when they file. See if you qualifiy and get started for free!</P>
    <ButtonLink aria-busy="false" href="https://my.upsolve.org/screener">Get Started</ButtonLink>
  </div>
);

export default SidebarCta;
